export const PSYCHOMETRIC_EVENTS = {
  TEST_READY: 'testReady',
  TEST_STARTED: 'testStarted',
  ITEM_LOADED: 'itemLoaded',
  ITEM_MOVE: 'itemMove',
  TEST_PAUSED: 'testPaused',
  TEST_RESUMED: 'testResumed',
  TEST_ENDED: 'testEnded',
  TOOL_USED: 'toolUsed',
  READY_TO_RESUME: 'readyToResume'
};